<p>operation-participants-selectors works!</p>
